import React from 'react';
import PropTypes from 'prop-types';
import sessionPropTypes from '@react/propTypes/sessionPropTypes';
import CartItemEventLayout from './CartItemEventLayout';
import CartItemEventProvider from './CartItemEventProvider';
import useEventRegistrationData from '@hooks/useEventRegistrationData';

const CartItemEvent = ({ eventDataForMember, onComponentLoaded = () => {}, setOptionalFullProgramEvents }) => {
    const eventRegistrationData = useEventRegistrationData({
        eventCode: eventDataForMember.code,
        memberId: eventDataForMember.memberId,
    });

    if (!eventRegistrationData) {
        return null;
    }

    return (
        <CartItemEventProvider eventDataForMember={eventDataForMember} eventRegistrationData={eventRegistrationData}>
            <CartItemEventLayout
                onComponentLoaded={onComponentLoaded}
                setOptionalFullProgramEvents={setOptionalFullProgramEvents}
            />
        </CartItemEventProvider>
    );
};

CartItemEvent.propTypes = {
    eventDataForMember: PropTypes.shape({
        code: PropTypes.string,
        memberId: PropTypes.number,
        name: PropTypes.string,
        sessions: PropTypes.arrayOf(sessionPropTypes),
    }),
    onComponentLoaded: PropTypes.func,
    setOptionalFullProgramEvents: PropTypes.func,
};

export default CartItemEvent;
